<template>
  <fb-list-body
      :pager="pager"
      :showBtnGroup="true"
      :showSearchForm="true"
      @handlePagerSizeChange="handlePagerSizeChange"
      @handlePagerIndexChange="handlePagerIndexChange"
  >
    <template slot="btn-group">
      <el-button @click="handleBatchUpdate">{{ $t('lang.设为付费食谱') }}</el-button>
      <el-button @click.native="cancelBatchUpdate">{{ $t('lang.取消') }}</el-button>
    </template>

    <template slot="search-form">
      <el-row>
        <el-col style="margin-bottom: 24px">
          <el-radio-group v-model="tabCurrent">
            <el-radio-button :label="i.recipeCategoryCode" v-for="i in recipeCategoryList" :key="i.recipeCategoryCode">
              {{ i.name }}
            </el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>

    </template>


    <template slot="table">
      <el-table :data="tableData" @selection-change="handleSelectionChange">

        <el-table-column type="selection" width="50"></el-table-column>

        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column :label="$t('lang.图片')">
          <template slot-scope="scope">
            <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.photo | filterImg(that)"/>

          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.食谱名称')">
          <template slot-scope="scope">
            <span
                :style="{'color':scope.row.onlineStatus=='online'?'#42bd83':scope.row.buyStatus!='charge'?'':'orange'}">{{ scope.row.name }}</span>
            <!-- <span :style="{'color':scope.row.buyStatus!='charge'?'':'orange'}" :style="{'color':scope.row.onlineStatus=='online'?'':'#42bd83'}">{{scope.row.name}}</span> -->
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.食谱编号')">
          <template slot-scope="scope">
            <span
                :style="{'color':scope.row.onlineStatus=='online'?'#42bd83':scope.row.buyStatus!='charge'?'':'orange'}">{{ scope.row.number }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.食谱版本号')">
          <template slot-scope="scope">
            <span
                :style="{'color':scope.row.onlineStatus=='online'?'#42bd83':scope.row.buyStatus!='charge'?'':'orange'}">{{ scope.row.modifyEdition }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.支持型号')">
          <template slot-scope="scope">
            <span
                :style="{'color':scope.row.onlineStatus=='online'?'#42bd83':scope.row.buyStatus!='charge'?'':'orange'}">{{ scope.row.productModels | join1 }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.是否在线食谱')">
          <template slot-scope="scope">
            <span :style="{'color':scope.row.onlineStatus=='online'?'#42bd83':scope.row.buyStatus!='charge'?'':'orange'}">
              {{ scope.row.onlineStatus != "online" ? $t('lang.否') : $t('lang.是') }}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.是否付费食谱')">
          <template slot-scope="scope">

            <span :class="scope.row.onlineStatus=='online'?'hidden':'show'"
                  :style="{'color':scope.row.buyStatus!='charge'?'':'orange'}">{{ scope.row.buyStatus != "charge" ? '否' : '是' }}</span>

          </template>
        </el-table-column>

        <el-table-column fixed="right" :label="$t('lang.操作')" width="360">
          <template slot-scope="scope">
            <el-button :class="scope.row.onlineStatus=='online'?'hidden':'show'" size="mini"
                       v-if="scope.row.buyStatus !== 'charge'" @click='handleUpdate(scope.row)' plain type="primary">
              {{ $t('lang.设为付费食谱') }}
            </el-button>
            <el-button :class="scope.row.onlineStatus=='online'?'hidden':'show'" size="mini" v-else
                       @click='cancelUpdate(scope.row.code)' plain type="danger">{{ $t('lang.取消') }}
            </el-button>
          </template>
        </el-table-column>


      </el-table>
    </template>

  </fb-list-body>
</template>

<script>

import {recipeCategoryList} from "../../js/common";

export default {
  name: "PayRecipeList",
  components: {},
  props: {
    timestamp: {
      type: Number,
      default: function () {
        return new Date().getTime();
      },
    },
  },
  filters: {
    join1(data) {
      if (data) {
        return data.join(' / ');
      } else {
        return ''
      }
    }
  },
  data() {
    return {
      api: {
        list: this.$api.recipe.list,
        batchUpdateBuyStatus: this.$api.recipe.batchUpdateBuyStatus,   // 批量和单个都是同一个接口
      },
      searchForm: {
        brandOwnerCode: this.$store.state.userInfo['brandOwnerCode'],
        status: 'released',
        recipeCategoryCode: ''
      },
      tableData: [],
      selection: [],
      pager: {
        pageSize: 10,
        pageIndex: 1,
        itemCount: 0,
      },
      tabCurrent: '',
      that: this,
      recipeCategoryList: [],
    };
  },
  computed: {
    searchParams() {
      return Object.assign({}, this.$route.query, this.searchForm, this.pager);
    },
  },
  watch: {
    tabCurrent: {
      handler(current) {
        if (current) {
          this.searchForm['recipeCategoryCode'] = current;
          this.handleSearch();
        }
      },
      immediate: true,
      deep: true,
    },
    timestamp() {
      this.handleSearch();
    },
    "pager.pageIndex": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams,
        });
        // this.handleSearch();
      },
      deep: true,
      immediate: true,
    },
    "pager.pageSize": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams,
        });
        this.handleSearch();
      },
      deep: true,
    },
  },
  methods: {
    handleUpdate(row) {
      let vm = this;
      let data = {
        "buyStatus": row.buyStatus != "charge" ? 'charge' : 'free',
        "recipeCodeList": [
          row.code
        ]
      }
      // vm.$confirm("您现在正在进行修改操作, 是否继续?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //     .then(() => {
      vm.$http
          .post(vm.api.batchUpdateBuyStatus, data)
          .then((resp) => {
            if (resp.data.status === 200) {
              vm.$message({type: "success", message: resp.data.desc});
              vm.handleSearch();
            } else {
              vm.$message({type: "error", message: resp.data.desc});
            }
          });
      // })
      // .catch(() => {
      //   // this.$message({
      //   //     type: 'info',
      //   //     message: '已取消删除'
      //   // });
      // });
    },
    cancelUpdate(code) {
      let vm = this;
      vm.$http
          .post(vm.api.batchUpdateBuyStatus, {"buyStatus": "free", "recipeCodeList": [code]})
          .then((resp) => {
            if (resp.data.status === 200) {
              vm.$message({type: "success", message: resp.data.desc});
              vm.handleSearch();
            } else {
              vm.$message({type: "error", message: resp.data.desc});
            }
          });
    },

    handleBatchUpdate() {
      let vm = this;

      if (!this.selection.length) {
        this.$message({type: "warning", message: vm.$t('lang.未选择记录')});
        return;
      }

      let codes = [];

      this.selection.forEach((e) => {
        codes.push(e.code);
      });

      this.$confirm(vm.$t('lang.您现在正在进行批量付费食谱设置操作, 是否继续?'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: "warning",
      })
          .then(() => {
            vm.$http.post(this.api.batchUpdateBuyStatus, {
              "buyStatus": "charge",
              "recipeCodeList": codes
            }).then((resp) => {
              if (resp.data.status === 200) {
                vm.$message({type: "success", message: resp.data.desc});
                vm.handleSearch();
              } else {
                vm.$message({type: "error", message: resp.data.desc});
              }
            });
          })
    },
    cancelBatchUpdate() {
      let vm = this;

      if (!this.selection.length) {
        this.$message({type: "warning", message: vm.$t('lang.未选择记录')});
        return;
      }

      let codes = [];

      this.selection.forEach((e) => {
        codes.push(e.code);
      });

      this.$confirm(vm.$t('lang.您现在正在进行批量设置取消操作, 是否继续?'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: "warning",
      })
          .then(() => {
            vm.$http.post(this.api.batchUpdateBuyStatus, {
              "buyStatus": "free",
              "recipeCodeList": codes
            }).then((resp) => {
              if (resp.data.status === 200) {
                vm.$message({type: "success", message: resp.data.desc});
                vm.handleSearch();
              } else {
                vm.$message({type: "error", message: resp.data.desc});
              }
            });
          })
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    handlePagerSizeChange(e) {
      this.pager.pageSize = e;
    },
    handlePagerIndexChange(e) {
      this.pager.pageIndex = e;
    },
    handleSearch() {
      let vm = this;
      this.$http.post(this.api.list, this.$qs.stringify(this.searchParams)).then((resp) => {
            for (let key in resp.data.data) {
              if (resp.data.data[key] instanceof Array) {
                vm.tableData = resp.data.data[key];
              }
            }

            //处理分页
            vm.pager.pageIndex = resp.data.data.pager.pageIndex;
            vm.pager.pageSize = resp.data.data.pager.pageSize;
            vm.pager.itemCount = resp.data.data.pager.itemCount;
          });
    },
  },
  async created() {
    for (let key in this.searchForm) {
      if (this.$route.query[key]) {
        this.searchForm[key] = this.$route.query[key];
      }
    }
    this.recipeCategoryList = await recipeCategoryList(this);
    if (this.recipeCategoryList.length) {
      this.tabCurrent = this.recipeCategoryList[0].recipeCategoryCode;
    }
  },
};
</script>

<style scoped>

/* .orange {
  color: orange;
} */

.hidden {
  display: none;
}

.show {
  display: block;
}

/deep/ .el-radio-button__inner {
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  margin-bottom: 8px;
  margin-right: 8px;
}


</style>
